export const Catalog = {
    path: '/catalogs',
    name: 'catalogs',
    component: () => import('@/views/Training/Catalog/CatalogPage.vue'),
    children: [
        {
            path: '/catalogs/add',
            name: 'catalogs.add',
            component: () => import('@/views/Training/Catalog/Form/CatalogForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/catalogs/edit/:id',
            name: 'catalogs.edit',
            component: () => import('@/views/Training/Catalog/Form/CatalogForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/catalogs/delete/:id',
            name: 'catalogs.delete',
            component: () => import('@/views/Training/Catalog/Form/CatalogForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/catalogs/view/:id',
            name: 'catalogs.view',
            component: () => import('@/views/Training/Catalog/Form/CatalogForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/catalogs/documents/:id',
            name: 'catalogs.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "TRAINING_CATALOG"}
        },
    ],
}
